// Take screenshot of the video stream for the poster image
// from the videoRef and setting it as the poster image.
// This is done when the game status is set to GameStatus.LastBets.

import { RefObject, useEffect } from 'react';

import { useGameStateSlice } from '../../../store/slices/game/selectors';
import { GameStatus } from '../../../store/slices/game/types';
import { useSettingsSlice } from '../../../store/slices/settings/selectors';

import { ScreenshotCapture } from './ScreenshotCapture';

interface IUseAutomaticallyPosterCreate {
  videoRef: RefObject<HTMLVideoElement | null>;
  setPoster: (poster: string) => void;
}

export const useAutomaticallyPosterCreate = ({ videoRef, setPoster }: IUseAutomaticallyPosterCreate): void => {
  const isStreamEnabled = useSettingsSlice.getIsStreamEnabled();
  const currentGameStatus = useGameStateSlice.getCurrentStatus();

  useEffect(() => {
    if (!isStreamEnabled) return;

    const video = videoRef?.current;

    if (!video) return;
    if (video.readyState >= 3) {
      if (currentGameStatus === GameStatus.LastBets) {
        const TakeScreenshot = ScreenshotCapture.getInstance();

        TakeScreenshot.makeScreenshot(video)
          .then((screenshotData) => {
            setPoster(screenshotData);
          })
          .catch((error) => {
            console.error('Error capturing screenshot:', error);
          });
      }
    }
  }, [isStreamEnabled, setPoster, videoRef, currentGameStatus]);
};
